import { render, staticRenderFns } from "./PgaOfferEvaluationCustomerOrderCreate.vue?vue&type=template&id=07ff42e9&scoped=true&"
import script from "./PgaOfferEvaluationCustomerOrderCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationCustomerOrderCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PgaOfferEvaluationCustomerOrderCreate.vue?vue&type=style&index=0&id=07ff42e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ff42e9",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VDivider,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VForm,VNavigationDrawer})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ff42e9')) {
      api.createRecord('07ff42e9', component.options)
    } else {
      api.reload('07ff42e9', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationCustomerOrderCreate.vue?vue&type=template&id=07ff42e9&scoped=true&", function () {
      api.rerender('07ff42e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/create/PgaOfferEvaluationCustomerOrderCreate.vue"
export default component.exports